import { FirebaseDataService } from "../../../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export function fetchGraphUniqueBought(statsObj,user, graph,) {
    return new Promise(async (resolve, reject) => {
    try {
        firebaseDataService.getStats(statsObj,user, graph, "barchart").subscribe((data) => {
          console.log("Fetched unique bought data:", data);
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}